import script from "./VUploadImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./VUploadImage.vue?vue&type=script&lang=ts&setup=true"

import "./VUploadImage.vue?vue&type=style&index=0&id=ecf44dba&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecf44dba"]])

export default __exports__